import styled from 'styled-components';

export const ScGamesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;

  & > .title {
    font-weight: bold;
    font-size: 20px;
    line-height: 1.3;
    text-align: center;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.whiteColor};
  }

  & > .games {
    width: 100%;
  }

  & > .btn-container {
    width: 180px;
  }
`;
